import { z } from "zod";
import { AuditTargetSchema } from "./audit-target";

/** HTTP evidence, not a claim that a transaction committed or a record changed. */
export const AuditRequestDetailsSchema = z.strictObject({
  method: z.enum([
    "GET",
    "HEAD",
    "POST",
    "PUT",
    "PATCH",
    "DELETE",
    "OPTIONS",
    "CONNECT",
    "TRACE",
    "OTHER",
  ]),
  status: z.number().int().min(100).max(599),
  durationMs: z.number().int().nonnegative(),
  kind: z.enum(["bootstrap", "session_exchange", "internal", "api", "document", "asset", "other"]),
  pathHash: z.string().regex(/^[a-f0-9]{64}$/),
  ...AuditTargetSchema.partial().shape,
});

export function customerRequestDetails(event: string, payload: unknown) {
  if (event !== "app.request.completed") return {};
  const result = AuditRequestDetailsSchema.safeParse(payload);
  return result.success ? result.data : {};
}
